import axios, { type AxiosResponse } from "axios";
import { sisikong_url } from "../../../api";

/**
 * Response type for the entity/image endpoint
 */
export interface ImageUploadResponse {
  id: string;
  url: string;
  small?: string;
  medium?: string;
  large?: string;
  file_name?: string;
}

/**
 * Uploads an image file to Cloudflare through the reviewer service.
 * @param data - The image file data to upload (FormData with "image" field)
 * @returns Promise with response containing the uploaded image URL and variants
 */
export async function uploadImage(data: FormData): Promise<AxiosResponse<ImageUploadResponse>> {
  return await axios.post<ImageUploadResponse>(
    `${sisikong_url}/reviewer/api/entity/images/`,
    data,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
}

/**
 * Entity colors types matching the backend EntityColorsDef structure
 */
export interface SecondaryBackgroundColors {
  dark?: string;
  light?: string;
}

export interface BackgroundColors {
  dark?: string;
  light?: string;
  secondary?: SecondaryBackgroundColors;
}

export interface TextColors {
  colored: string;
}

export interface EntityColors {
  base: string;
  background: BackgroundColors;
  text?: TextColors;
}

/**
 * Request type for updating subagent
 */
export interface UpdateSubAgentRequest {
  subagent_id: number;
  logo_url?: string;
  entity_colors?: EntityColors;
}

/**
 * Response type for updating subagent
 */
export interface UpdateSubAgentResponse {
  message: string;
  logo_url?: string;
  entity_colors?: EntityColors;
}

/**
 * Updates a subagent using Apollo B2B authentication.
 * @param data - The subagent update data (subagent_id, optional logo_url, and optional entity_colors)
 * @param token - The authentication token
 * @returns Promise with response containing the update result
 */
export async function updateSubAgent(
  data: UpdateSubAgentRequest,
  token: string,
): Promise<AxiosResponse<UpdateSubAgentResponse>> {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return await axios.patch<UpdateSubAgentResponse>(
    `${sisikong_url}/crm/external/apollo-b2b/subagent`,
    data,
    { headers },
  );
}
